import { axiosApiInstance } from "../axios";

export interface ExpenseUserOption {
  value: number;
  label: string;
}

export async function getExpenseUserOptions(): Promise<ExpenseUserOption[]> {
  const response = await axiosApiInstance.get("expenses/users/options", {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("authToken")}`,
    },
  });

  return response.data;
}
